<template>
  <div class="conversation-list d-flex flex-column" :class="{
    'show-all-layout': agencySettings.enableConversationAssignment
  }">
    <div class="conversation-list--show-all d-flex justify-content-between align-items-center gap-3 px-3">
      <div>
        <span v-if="agencySettings.enableConversationAssignment" class="text-left form-check form-switch">
          <input class="form-check-input" v-model="showAll" type="checkbox" role="switch" id="id-showAllConversations"
            name="showAllConversations" />
          <label class="form-check-label" for="id-showAllConversations">Show all</label>
        </span>
      </div>
      <CallTakerMode v-if="agencySettings.enableCalltakerMode" />
    </div>
    <div class=" conversation-list--content">
        <div v-if="!agencySettings.enableConversationAssignment && activeConversations.length > 0"
          class="conversation-list--active">
          <div class="d-flex align-items-center justify-content-start fw-bold bg-info text-white px-2">
            <strong>{{ `ACTIVE CONVERSATIONS (${activeConversations.length})` }}</strong>
          </div>

          <ul class="list-style-none">
            <li>
              <div class="message-center chat-scroll">
                <a @click="goToConversation(conversation.conversation_id)" :key="conversation.conversation_id"
                  role="button" class="chat-user border-bottom px-0 py-0" v-for="conversation in activeConversations">
                  <ConversationRecipient :conversation="conversation" />
                </a>
              </div>
            </li>
          </ul>
        </div>

        <div v-if="agencySettings.enableConversationAssignment" class="conversation-list--assignments">
          <div v-if="assigned.length > 0" class="conversation-list--assigned" :class="{
          'full-height': unassigned.length == 0
        }">

            <div class="d-flex align-items-center justify-content-start fw-bold bg-info text-white px-2">
              <b>{{ `ASSIGNED (${assigned.length})` }}</b>
            </div>

            <ul class="list-style-none">
              <li>
                <div class="message-center chat-scroll">
                  <a @click="goToConversation(conversation.conversation_id)" :key="conversation.conversation_id"
                    role="button" class="chat-user border-bottom px-0 py-0" v-for="conversation in assigned">
                    <ConversationRecipient :conversation="conversation" />
                  </a>
                </div>
              </li>
            </ul>

          </div>
          <div v-if="unassigned.length > 0" class="conversation-list--unassigned" :class="{
          'full-height': assigned.length == 0
        }">
            <div class="d-flex align-items-center justify-content-start fw-bold bg-info text-white px-2">
              <b>{{ `UNASSIGNED (${unassigned.length})` }}</b>
            </div>

            <ul class="list-style-none">
              <li>
                <div class="message-center chat-scroll">
                  <a @click="assignConversation(conversation.conversation_id)" :key="conversation.conversation_id"
                    role="button" class="chat-user border-bottom px-0 py-0" v-for="conversation in unassigned">
                    <ConversationRecipient :conversation="conversation" />
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import ConversationRecipient from "./ConversationRecipient";
import { mapGetters, mapState } from "vuex";
import "flashing-page-title-notification/dist/index";
import { EventBus } from "../../events/eventBus";
import AssignConversation from "./AssignConversation";
import moment from "moment-timezone";
import CallTakerMode from "@/components/conversations/CallTakerMode";

export default {
  name: "ConversationList",
  components: {
    ConversationRecipient,
    CallTakerMode,
  },
  data() {
    return {
      removeClosedConversationsInterval: null,
    };
  },
  computed: {
    ...mapGetters("conversations", ["activeConversations"]),
    ...mapGetters("user", ["currentUser", "showAllConversations"]),
    ...mapGetters("agency", ["agencySettings"]),
    ...mapState({
      feedStatus: (state) => state.agency.feedStatus,
    }),
    showAll: {
      get() {
        return this.showAllConversations;
      },
      set(val) {
        this.$store.commit("user/setShowAllConversations", val);
      }
    },
    assigned: function () {
      if (this.showAll === true) {
        const activeConverations = this.activeConversations
          .map(i => {
            return {
              ...i,
              updatedAt: i.last_message_at ? i.last_message_at : i.updated_at
            };
          })
          .filter(i => i.operator_id !== null && i.status === "active")
          .sort((a, b) => b.updatedAt - a.updatedAt);
        const closedConversations = this.activeConversations
          .filter(i => i.operator_id !== null && i.status === "closed")
          .sort((a, b) => b.closed_at - a.closed_at);
        return activeConverations.concat(closedConversations);
      } else {
        const activeConverations = this.activeConversations
          .map(i => {
            return {
              ...i,
              updatedAt: i.last_message_at ? i.last_message_at : i.updated_at
            };
          })
          .filter(i => i.operator_id === this.currentUser.user_id && i.status === "active")
          .sort((a, b) => b.updatedAt - a.updatedAt);
        const closedConversations = this.activeConversations
          .filter(i => i.operator_id === this.currentUser.user_id && i.status === "closed")
          .sort((a, b) => b.closed_at - a.closed_at);
        return activeConverations.concat(closedConversations);
      }
    },
    unassigned: function () {
      return this.activeConversations
        .map(i => {
          return {
            ...i,
            updatedAt: i.last_message_at ? i.last_message_at : i.updated_at
          };
        })
        .filter(i => i.operator_id === null)
        .sort((a, b) => b.updatedAt - a.updatedAt);
    },
    hasUnread() {
      return this.activeConversations.some((ac) => ac.unread !== 0);
    },
  },
  methods: {
    agentConnected() {
      return this.feedStatus;
    },
    goToConversation(conversationId) {
      if (!this.agentConnected()) {
        alert(
          "Your agent is offline. You must be in available status to access conversations."
        );
        return;
      }

      this.$router
        .push({ path: `/conversations/${conversationId}` })
        .catch(() => { });
    },
    assignConversation(id) {
      const $ = window.$;
      $("#id-modal-container").modal();
      EventBus.$emit("open", {
        component: AssignConversation,
        title: "Assign Conversation",
        props: {
          conversationId: id, userId: this.currentUser.user_id
        }
      });
    },
    removeClosedConversations() {
      const closedConversations = this.assigned.filter(i => i.status === "closed");
      if (closedConversations.length === 0 && this.removeClosedConversationsInterval) {
        clearInterval(this.removeClosedConversationsInterval);
        this.removeClosedConversationsInterval = null;
      }
      const currentTime = moment().utc().valueOf();
      const elapsedTime = 5 * 60 * 1000;
      closedConversations.forEach(conversation => {
        const { closed_at, conversation_id } = conversation;
        if (currentTime - closed_at >= elapsedTime) {
          this.$store.commit("conversations/removeConversation", conversation_id);
        }
      });
    }
  },
  watch: {
    assigned: {
      handler(conversations) {
        const closedConversations = conversations.filter(i => i.status === "closed");
        if (closedConversations.length === 0) {
          if (this.removeClosedConversationsInterval) {
            clearInterval(this.removeClosedConversationsInterval);
            this.removeClosedConversationsInterval = null;
          }
        } else {
          if (!this.removeClosedConversationsInterval) {
            this.removeClosedConversationsInterval = setInterval(() => {
              this.removeClosedConversations();
            }, 5000);
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    EventBus.$on("conversationReadEvent", (conversationId) => {
      this.goToConversation(conversationId);
    });
  },
  beforeDestroy() {
    if (this.removeClosedConversationsInterval) {
      clearInterval(this.removeClosedConversationsInterval);
      this.removeClosedConversationsInterval = null;
    }
  }
};
</script>

<style lang="scss">
.conversation-list {
  width: 100%;
  height: 100%;

  &--show-all {
    width: 100%;
    height: 32px;
  }

  &--content {
    width: 100%;
    height: 100%;
  }

  &.show-all-layout {
    .conversation-list--content {
      height: calc(100% - 32px);
    }
  }

  &--active {
    width: 100%;
    height: 100%;

    >div {
      width: 100%;
      height: 26px;
      font-size: 12px;
    }

    >ul {
      width: 100%;
      height: calc(100% - 26px);
      overflow-y: auto;
    }
  }

  &--assignments {
    width: 100%;
    height: 100%;
  }

  &--assigned,
  &--unassigned {
    width: 100%;
    height: 50%;

    >div {
      width: 100%;
      height: 26px;
      font-size: 12px;
    }

    >ul {
      height: calc(100% - 26px);
      overflow-y: auto;
    }

    &.full-height {
      height: 100%;
    }
  }
}
</style>